/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsCalculatorHistory204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsCalculatorHistory505Schema = z.any();

export const optionsCalculatorHistoryMutationResponseSchema = z.lazy(() => optionsCalculatorHistory204Schema);
